import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDZKVszxLnJcgrkhIzUkUbqKS89rtTeKCA",
  authDomain: "document-analysis-a166e.firebaseapp.com",
  projectId: "document-analysis-a166e",
  storageBucket: "document-analysis-a166e.firebasestorage.app",
  messagingSenderId: "822944814773",
  appId: "1:822944814773:web:7cfcc05c357331f83f90fc",
  measurementId: "G-CEHPRMRGF2",
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
const analytics = getAnalytics(app);

export default app;
